<template>
  <b-modal v-model="showLocal" @hidden="hide" dialog-class="container-description" centered no-close-on-esc
    no-close-on-backdrop hide-footer hide-header size="lg" content-class="modal-description" id="complaint-modal">
    <section>
      <h2 class="modal-title text-center my-0">
        ¡Tu reclamo ha sido registrado con éxito!
      </h2>

      <ul class="mt-4" v-if="complaintResult">
        <li class="mb-1"><b>Código:</b> <span class="text-muted">N.° {{ complaintResult.code }}</span></li>
        <li class="mb-1"><b>Fecha y hora de registro:</b> <span class="text-muted"
            v-local-date:hour="complaintResult.createdAt"></span></li>
        <li class="mb-1"><b>Plazo de respuesta:</b> <span class="text-muted">Máximo 15 días hábiles</span></li>
      </ul>

      <h4 class="small text-center mt-4">
        <b>Recibirás la respuesta en el correo que registraste.</b>
      </h4>

      <div class="text-center mt-4" @click="hide()">
        <a :href="setComplaintUrl" target="_blank" class="button btn-sm rounded button-primary">Ver reclamo</a>
        <!-- <button type="button" class="btn btn-sm btn-light mx-2">Descargar PDF <i class="ri-file-download-line"></i></button> -->
      </div>

      <p class="modal-description mt-4">
        Con el envío de este formulario, el usuario valida la información consignada y declara haber sido informado por
        <b>{{ business.name }}</b> sobre el procedimiento, plazo de atención y medio de respuesta.
      </p>

      <p>
        En caso el reclamo resulte procedente o improcedente, la decisión será notificada al correo electrónico
        registrado.
      </p>

      <p>
        De acuerdo con la Ley N.° 29571:
      </p>

      <ul class="second-list">
        <li>
          El reclamo se registra con un código único.
        </li>
        <li>
          La presentación de un reclamo no impide acudir a otras vías de solución de controversias ni constituye
          requisito previo para presentar una denuncia ante Indecopi.
        </li>
        <li>
          En caso no se consigne como mínimo el nombre, documento de identidad, correo y descripción, el reclamo se
          considera no presentado.
        </li>
      </ul>

      <p class="mb-1">
        Al registrar su reclamo o queja, se generará un código único que será enviado a su correo electrónico para su
        seguimiento.
      </p>

      <p class="mb-1">
        En caso no se consigne como mínimo el nombre, número de documento, dirección o correo electrónico, y la
        descripción del reclamo o queja, este será considerado no presentado, conforme al artículo 5 del Reglamento del
        Libro de Reclamaciones.
      </p>

      <p class="mb-1">
        La formulación del reclamo no impide acudir a otras vías de solución de controversias ni es requisito previo
        para presentar una denuncia ante INDECOPI.
      </p>

      <p class="mb-1">
        Este establecimiento cuenta con un <b>Libro de Reclamaciones</b> a disposición del consumidor, conforme a lo
        exigido
        por la Ley.
      </p>

      <div class="text-center mt-4" @click="hide()">
        <button type="button" class="btn btn-primary">Entendido</button>
      </div>
    </section>
  </b-modal>
</template>


<script>
import { ModalMixin } from "@/core/mixins";

export default {
  name: "ComplaintModal",
  mixins: [ModalMixin],
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    business: Object,
    complaintResult: Object
  },
  computed: {
    setComplaintUrl() {
      let slug = window.location.href;

      // Usamos el objeto URL
      slug = new URL(slug).pathname.split("/").filter(Boolean).pop();

      if (this.complaintResult) {
        return `https://zet.wize.pe/${slug}/${this.complaintResult.code}`
      }

      return ''
    }
  }
};
</script>
<style lang="styl">
@import "../Styles/complaint-modal.styl";
</style>
